if(!customElements.get('menu-desktop')) {
    customElements.define('menu-desktop',
         class menuDesktop extends HTMLElement {
             constructor() {
                 super();
                 let self = this;
                 this.init(self);
             }
             init (self) {
                 const openHeaderMenuBtn = this.querySelector('.openHeaderMenuBtn');
                 const headerMenu = this.querySelector('.header-menu-desktop');

                 openHeaderMenuBtn.addEventListener('click', function () {
                     self.openMenu(headerMenu, openHeaderMenuBtn);
                 })
             }

             openMenu(headerMenu, openHeaderMenuBtn) {
                 headerMenu.classList.toggle('is-open');
                 openHeaderMenuBtn.classList.toggle('is-open');
                 if(headerMenu.classList.contains('is-open')) {
                     headerMenu.classList.add('open');
                     document.body.classList.add('not-scroll');
                 } else {
                     headerMenu.classList.remove('open');
                     document.body.classList.remove('not-scroll');
                 }

                 let mainSubmenu = headerMenu.querySelector('.main-super-menu');
                 let heightFooterMenu = 0;

                 if(headerMenu.querySelector('.footer-menu')) {
                     heightFooterMenu = headerMenu.querySelector('.footer-menu').offsetHeight
                 }
                 mainSubmenu.style.maxHeight = `calc(100% - ${heightFooterMenu}px)`;
             }
         }
    )
}